var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "renshou-sync-log" },
    [
      _c(
        "el-dialog",
        {
          attrs: { title: "仁寿同步日志", visible: _vm.isShow, width: "80%" },
          on: {
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "div",
            { staticClass: "log-content" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.logList,
                    size: "small",
                    border: "",
                    "max-height": "600",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "ID",
                      width: "90",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "storeId",
                      label: "店铺ID",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerId",
                      label: "客户ID",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "syncType",
                      label: "同步类型",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.syncType === "FULL"
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "primary", size: "small" } },
                                  [_vm._v("全量同步")]
                                )
                              : scope.row.syncType === "INCREMENT"
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "success", size: "small" } },
                                  [_vm._v("增量同步")]
                                )
                              : scope.row.syncType === "UPDATE"
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "warning", size: "small" } },
                                  [_vm._v("修改同步")]
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.syncType || "-")),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "syncBatchId",
                      label: "同步批次ID",
                      width: "180",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "syncStartTime",
                      label: "同步开始时间",
                      width: "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "syncEndTime",
                      label: "同步结束时间",
                      width: "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "syncStatus",
                      label: "同步状态",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    _vm.normalizeSyncStatus(
                                      scope.row.syncStatus
                                    ) === 1
                                      ? "success"
                                      : _vm.normalizeSyncStatus(
                                          scope.row.syncStatus
                                        ) === 0
                                      ? "danger"
                                      : "info",
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.normalizeSyncStatus(
                                        scope.row.syncStatus
                                      ) === 1
                                        ? "成功"
                                        : _vm.normalizeSyncStatus(
                                            scope.row.syncStatus
                                          ) === 0
                                        ? "失败"
                                        : "-"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalCount",
                      label: "同步总记录数",
                      width: "120",
                      align: "right",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "successCount",
                      label: "同步成功记录数",
                      width: "140",
                      align: "right",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "failCount",
                      label: "同步失败记录数",
                      width: "140",
                      align: "right",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "failDetails",
                      label: "失败详情",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.failDetails
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatFailDetails(
                                        scope.row.failDetails
                                      )
                                    )
                                  ),
                                ])
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "errorMessage",
                      label: "错误信息",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      width: "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "updateTime",
                      label: "更新时间",
                      width: "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "90",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.close } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("SyncLogInfo", { ref: "SyncLogInfoRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }